// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-modal {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, -100%);
  border-radius: 10px;
  padding: 8px;
  width: 260px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  color: #333;
  z-index: 20;
  text-align: center;
  background-color: #fffbea;
  border: 1px solid #f0e68c;
}
.mini-modal p {
  color: #3c4143;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 0 !important;
}
.mini-modal::before, .mini-modal::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-style: solid;
}
.mini-modal::before {
  bottom: -18px;
  border-width: 9px;
  border-color: #f0e68c transparent transparent transparent;
  z-index: 1;
}
.mini-modal::after {
  bottom: -15px;
  border-width: 8px;
  border-color: #fffbea transparent transparent transparent;
  z-index: 2;
}
.mini-modal--green {
  background-color: #f6fefa;
  border: 1px solid #84f4bc;
}
.mini-modal--green::before {
  border-color: #84f4bc transparent transparent transparent;
}
.mini-modal--green::after {
  border-color: #f6fefa transparent transparent transparent;
}
.mini-modal--yellow {
  background-color: #fffef5;
  border: 1px solid #ffed69;
}
.mini-modal--yellow::before {
  border-color: #ffed69 transparent transparent transparent;
}
.mini-modal--yellow::after {
  border-color: #fffef5 transparent transparent transparent;
}
.mini-modal--orange {
  background-color: #fff9f5;
  border: 1px solid #ffb380;
}
.mini-modal--orange::before {
  border-color: #ffb380 transparent transparent transparent;
}
.mini-modal--orange::after {
  border-color: #fff9f5 transparent transparent transparent;
}
.mini-modal--red {
  background-color: #fef5f6;
  border: 1px solid #f4455a;
}
.mini-modal--red::before {
  border-color: #f4455a transparent transparent transparent;
}
.mini-modal--red::after {
  border-color: #fef5f6 transparent transparent transparent;
}
@media (max-width: 1369px) {
  .mini-modal--pos-center {
    left: 50%;
    transform: translate(-50%, -100%);
  }
  .mini-modal--pos-center::before, .mini-modal--pos-center::after {
    left: 50%;
    transform: translateX(-50%);
  }
  .mini-modal--pos-left {
    right: 0;
    left: auto;
    transform: translate(0, -100%);
  }
  .mini-modal--pos-left::before, .mini-modal--pos-left::after {
    left: auto;
    right: 20px;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/mini-modal/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iCAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACJ;AAEE;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,iBAAA;EACA,yDAAA;EACA,UAAA;AAFJ;AAKE;EACE,aAAA;EACA,iBAAA;EACA,yDAAA;EACA,UAAA;AAHJ;AAME;EACE,yBAAA;EACA,yBAAA;AAJJ;AAMI;EACE,yDAAA;AAJN;AAOI;EACE,yDAAA;AALN;AASE;EACE,yBAAA;EACA,yBAAA;AAPJ;AASI;EACE,yDAAA;AAPN;AAUI;EACE,yDAAA;AARN;AAYE;EACE,yBAAA;EACA,yBAAA;AAVJ;AAYI;EACE,yDAAA;AAVN;AAaI;EACE,yDAAA;AAXN;AAeE;EACE,yBAAA;EACA,yBAAA;AAbJ;AAeI;EACE,yDAAA;AAbN;AAgBI;EACE,yDAAA;AAdN;AAkBE;EACE;IACE,SAAA;IACA,iCAAA;EAhBJ;EAkBI;IAEE,SAAA;IACA,2BAAA;EAjBN;EAqBE;IACE,QAAA;IACA,UAAA;IACA,8BAAA;EAnBJ;EAqBI;IAEE,UAAA;IACA,WAAA;IACA,eAAA;EApBN;AACF","sourcesContent":[".mini-modal {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translate(-50%, -100%);\n  border-radius: 10px;\n  padding: 8px;\n  width: 260px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  color: #333;\n  z-index: 20;\n  text-align: center;\n  background-color: #fffbea;\n  border: 1px solid #f0e68c;\n\n  p {\n    color: #3c4143;\n    font-size: 11px;\n    font-weight: 400;\n    margin-bottom: 0 !important;\n  }\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    border-style: solid;\n  }\n\n  &::before {\n    bottom: -18px;\n    border-width: 9px;\n    border-color: #f0e68c transparent transparent transparent;\n    z-index: 1;\n  }\n\n  &::after {\n    bottom: -15px;\n    border-width: 8px;\n    border-color: #fffbea transparent transparent transparent;\n    z-index: 2;\n  }\n\n  &--green {\n    background-color: #f6fefa;\n    border: 1px solid #84f4bc;\n\n    &::before {\n      border-color: #84f4bc transparent transparent transparent;\n    }\n\n    &::after {\n      border-color: #f6fefa transparent transparent transparent;\n    }\n  }\n\n  &--yellow {\n    background-color: #fffef5;\n    border: 1px solid #ffed69;\n\n    &::before {\n      border-color: #ffed69 transparent transparent transparent;\n    }\n\n    &::after {\n      border-color: #fffef5 transparent transparent transparent;\n    }\n  }\n\n  &--orange {\n    background-color: #fff9f5;\n    border: 1px solid #ffb380;\n\n    &::before {\n      border-color: #ffb380 transparent transparent transparent;\n    }\n\n    &::after {\n      border-color: #fff9f5 transparent transparent transparent;\n    }\n  }\n\n  &--red {\n    background-color: #fef5f6;\n    border: 1px solid #f4455a;\n\n    &::before {\n      border-color: #f4455a transparent transparent transparent;\n    }\n\n    &::after {\n      border-color: #fef5f6 transparent transparent transparent;\n    }\n  }\n\n  @media (max-width: 1369px) {\n    &--pos-center {\n      left: 50%;\n      transform: translate(-50%, -100%);\n\n      &::before,\n      &::after {\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n\n    &--pos-left {\n      right: 0;\n      left: auto;\n      transform: translate(0, -100%);\n\n      &::before,\n      &::after {\n        left: auto;\n        right: 20px;\n        transform: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
